import { render } from "./start-content.vue?vue&type=template&id=120eff37&scoped=true"
import script from "./start-content.vue?vue&type=script&lang=js"
export * from "./start-content.vue?vue&type=script&lang=js"

import "./start-content.vue?vue&type=style&index=0&id=120eff37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120eff37"]])

export default __exports__